/**
 * Various utility functions we want to share across components
 */
const isIos = !!(/iPhone|iPad|iPod/i.test(navigator.userAgent || ''));
const hasWebRTC = !!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia);
const isAndroid = !!(/android/i.test(navigator.userAgent || ''));
// We need to exclude CriOS to avoid false positives with iOS Chrome
const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent || '') &&
  !(/CriOS/i.test(navigator.userAgent || '')) &&
  !(/FxiOS/i.test(navigator.userAgent || ''));

/**
 * Variables pertaining to recording
 */
const recordingMethod = (isSafari) ? 'custom' : 'RecordRTC';

export default {
  isIncompatibleVideo(fileExtension) {
    const incompatibleExtensions = [
      'webm', 'mpg', 'mp2', 'mpeg', 'mpe', 'mpv',
      'ogg', 'm4p', 'm4v', 'avi', 'wmv',
      'mov', 'qt', 'flv', 'swf', 'avchd',
    ];
    return (incompatibleExtensions.indexOf(fileExtension) !== -1);
  },
  isMp4(fileExtension) {
    return (fileExtension === 'mp4');
  },
  getFileExtension(fullPath) {
    let filename
      , fileExtension;

    const startIndex = (fullPath.indexOf('\\') >= 0 ? fullPath.lastIndexOf('\\') : fullPath.lastIndexOf('/'));
    filename = fullPath.substring(startIndex);
    if (filename.indexOf('\\') === 0 || filename.indexOf('/') === 0) {
      filename = filename.substring(1);
    }
    const suffixIndex = filename.lastIndexOf('.');
    fileExtension = filename.substring(suffixIndex + 1);
    if (fileExtension && fileExtension.toLowerCase) {
      fileExtension = fileExtension.toLowerCase();
    }

    return fileExtension;
  },
  isLargeViewport() {
    const w = window,
      d = document,
      e = d.documentElement,
      g = d.getElementsByTagName('body')[0],
      width = w.innerWidth || e.clientWidth || g.clientWidth;
    return (width >= 992);
  },
  isMediumViewport() {
    const w = window,
      d = document,
      e = d.documentElement,
      g = d.getElementsByTagName('body')[0],
      width = w.innerWidth || e.clientWidth || g.clientWidth;
    return (width < 992 && width > 767);
  },
  isSmallViewport() {
    const w = window,
      d = document,
      e = d.documentElement,
      g = d.getElementsByTagName('body')[0],
      width = w.innerWidth || e.clientWidth || g.clientWidth;
    return (width <= 767);
  },
  getViewportHeight() {
    const w = window,
      d = document,
      e = d.documentElement,
      g = d.getElementsByTagName('body')[0],
      h = w.innerHeight || e.clientHeight || g.clientHeight;
    return h;
  },
  isIos,
  hasWebRTC,
  isAndroid,
  isSafari,
  recordingMethod,
};
